import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import composedDailyLogsContainer from "../../../containers/DailyLogsContainer";
import DailyLogList from "./DailyLogsList";
import { useEffect } from "react";
import { redirectWindowUrl } from "../../../services/GlobalUrls";
import DailyLogsListMobile from "./DailyLogsListMobile";
import { Tooltip } from "@mui/material";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Speed Dial - Start
import Box from "@mui/material/Box";
const DailyLogMainComponent = ({ deviceInfo, ...props }) => {
  const [viewToolTip, setViewToolTip] = useState(false);
  const [dailyLogsTab, setDailyLogsTab] = useState("Pending");
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const changeDailyLogTabs = (dailyLogsTabValue = "") => {
    if (dailyLogsTabValue) {
      setDailyLogsTab(dailyLogsTabValue);
    } else {
      setDailyLogsTab("Pending");
    }
  };
  // Print Content - Start
  const printContent = (dailyLogsTabValue = "") => {
    if (deviceInfo == "Mobile") {
      return <DailyLogsListMobile dailyLogsStatus={dailyLogsTabValue} />;
    } else {
      return (
        <>
          <DailyLogList dailyLogsStatus={dailyLogsTabValue} />
        </>
      );
    }
  };
  // Print Content - End
  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 mb-2">
                <h5 className="font-weight-700 pull-left text-uppercase">
                  Daily Logs
                </h5>
                <div className="col-sm-12">
                  {deviceInfo && deviceInfo == "Mobile" ? (
                    <Tooltip
                      title="Create Daily Logs"
                      className="text-sm"
                      open={viewToolTip}
                      placement="top"
                    >
                      <a
                        href={"/create-daily-logs"}
                        className="pull-right btn btn-success"
                        onTouchStart={(e) => {
                          setViewToolTip(true);
                        }}
                        onTouchEnd={(e) => {
                          setViewToolTip(false);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </a>
                    </Tooltip>
                  ) : (
                    <a
                      href="/create-daily-logs"
                      className="pull-right site-button btn-sm"
                    >
                      Create Daily Logs
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <>
            {deviceInfo == "Mobile" ? (
              <Box
                sx={{
                  flexGrow: 1,
                  // maxWidth: { xs: 320, sm: 480 },
                  bgcolor: "background.paper",
                }}
                className="mb-3"
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="visible arrows tabs example"
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      "&.Mui-disabled": { opacity: 0.3 },
                    },
                  }}
                  className=""
                >
                  <Tab
                    label="Pending"
                    onClick={(e) => changeDailyLogTabs("Pending")}
                  />
                  <Tab
                    label="Completed"
                    onClick={(e) => changeDailyLogTabs("Completed")}
                  />
                </Tabs>
              </Box>
            ) : (
              <ul
                className="nav nav-tabs bg-dark p-1"
                style={{
                  borderRadius: "25px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <li className={"nav-item cursor-pointer p-2"}>
                  <a
                    className={
                      "nav-link " +
                      (dailyLogsTab == "Pending"
                        ? "text-primary active bold"
                        : "text-white")
                    }
                    id="tab1"
                    style={{ borderRadius: "50px" }}
                    onClick={(e) => changeDailyLogTabs("Pending")}
                  >
                    Pending
                  </a>
                </li>
                <li className={"nav-item cursor-pointer p-2"}>
                  <a
                    className={
                      "nav-link " +
                      (dailyLogsTab == "Completed"
                        ? "text-primary active"
                        : "text-white")
                    }
                    onClick={(e) => changeDailyLogTabs("Completed")}
                    id="tab2"
                    style={{ borderRadius: "50px" }}
                  >
                    Completed
                  </a>
                </li>
              </ul>
            )}

            <div className="row">
              {dailyLogsTab == "Pending" && <>{printContent("Pending")}</>}
              {dailyLogsTab == "Completed" && <>{printContent("Completed")}</>}
            </div>
          </>
        </div>
      </div>
    </React.Fragment>
  );
};

export default composedDailyLogsContainer(DailyLogMainComponent);
